import React from 'react';
import { OpeninghoursResult, OpeningHoursResults } from '../types';
import styled from 'styled-components';
import css from '@styled-system/css';

const Label = styled.span`
  padding-right: ${props => props.theme.space.large};
  font-size: ${props => props.theme.fontSizes.text.medium} !important;
`;

const Value = styled.span`
  white-space: nowrap;
  font-size: ${props => props.theme.fontSizes.text.medium} !important;
`;

const TableRow = styled.tr`
  background-color: transparent !important;
  ${css({
    whiteSpace: ['nowrap']
  })}
`;

const TableHours = styled.td`
  ${css({
    marginBottom: ['0', 'small', '0'],
    float: ['none', 'left', 'none']
  })}
  border: 0;
  padding: 0;
  text-align: left !important;
`;

const TableDays = styled.td`
  border: 0;
  padding: 0;
  float: left;
`;

export default function BusinessHours(props: OpeningHoursResults) {
  const { opening } = props;
  let openingDetailItems = null;
  if (opening) {
    openingDetailItems = opening.map(
      (openingDetail: OpeninghoursResult, index: number) => (
        <TableRow key={index}>
          <TableDays>
            <Label>{openingDetail.day}</Label>
          </TableDays>
          <TableHours>
            <Value>{openingDetail.openingTime}</Value>
          </TableHours>
        </TableRow>
      )
    );
  }

  return (
    <table>
      <tbody>{openingDetailItems}</tbody>
    </table>
  );
}
